module.exports = __webpack_public_path__ + "static/media/card-vps-n8n-es.9fc0c65d.png";